import type { SpartacuxCustomerManagementState } from '@/customerManagement/customerManagement.model';
import { CrossBorderVat } from '@/domains/proB2BAnimation/interfaces/crossBorderVat';
import { Intracommunity, VatStatus } from '@/generated/graphql/types';

import type { CompanyWithVat } from './interfaces';
import { initialProCompany } from './model';

export const selectCompany = (
  state: SpartacuxCustomerManagementState,
): CompanyWithVat =>
  state.customerManagement?.company?.data || initialProCompany;

export const selectVat = (
  state: SpartacuxCustomerManagementState,
): CrossBorderVat =>
  state.customerManagement?.company?.data.crossBorderVat ||
  initialProCompany.crossBorderVat;

export const selectIsIntracom = (
  state: SpartacuxCustomerManagementState,
): Intracommunity | undefined =>
  state.customerManagement?.company?.data.crossBorderVat.isIntracommunity ||
  undefined;

export const selectIsFetching = (state: SpartacuxCustomerManagementState) =>
  state.customerManagement?.company?.isFetching;

export const selectIsNorthernIreland = (
  state: SpartacuxCustomerManagementState,
): boolean | undefined =>
  state.customerManagement?.company?.data.isNorthernIreland ?? undefined;

export const selectHasError = (state: SpartacuxCustomerManagementState) =>
  state.customerManagement?.company?.error.hasError;

export const selectErrorKey = (state: SpartacuxCustomerManagementState) =>
  state.customerManagement?.company?.error.errorKey;

export const selectHasSucceeded = (state: SpartacuxCustomerManagementState) =>
  state.customerManagement?.company?.hasSucceeded;

const invalidStatuses = [VatStatus.INVALID_AUTO, VatStatus.INVALID_MANUAL];

export const selectIsVatInvalid = (state: SpartacuxCustomerManagementState) => {
  const status =
    state.customerManagement?.company?.data?.crossBorderVat.vatStatus;

  const isInvalid = status && invalidStatuses.includes(status);
  return isInvalid;
};

export const selectIsVatNotSentToValidate = (
  state: SpartacuxCustomerManagementState,
) =>
  state.customerManagement?.company?.data?.crossBorderVat.vatStatus ===
  VatStatus.NOT_SENT_TO_VALIDATE;

export const selectIsFraudSuspected = (
  state: SpartacuxCustomerManagementState,
) => state.customerManagement?.company?.data?.crossBorderVat.isFraudSuspected;
